import React from 'react'

export interface FieldMappingEntry {
  excelColumn: string
  formFieldId: number
  formFieldLabel: string
  formFieldType: string
  prefillFromExcel: boolean
  editable: boolean
  editableOnCondition?: Record<string, unknown> | null
  isEditField?: boolean
  parentFieldId?: number
  isTableCell?: boolean
  tableRowIndex?: number
  tableColIndex?: number
  useAsRecipientName?: boolean
}

interface Props {
  mapping: FieldMappingEntry[]
}

const PrefillFieldMappingTable: React.FC<Props> = ({ mapping }) => (
  <div className='table-responsive mt-3'>
    <table className='table table-bordered table-sm'>
      <thead>
        <tr>
          <th>Excel Column</th>
          <th>Form Field</th>
        </tr>
      </thead>
      <tbody>
        {mapping.map((entry) => (
          <tr key={entry.excelColumn}>
            <td>
              <code>{entry.excelColumn}</code>
            </td>
            <td>
              {entry.formFieldLabel} <span className='text-muted'>({entry.formFieldType})</span>
              {entry.isEditField && (
                <span className='badge bg-warning text-dark ms-1'>Edit-only</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

export default PrefillFieldMappingTable
